var React = require('react');

function Blobik2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"svgcid--p25fi-26yyt9","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"d":"M154.195 69.197c-6.615 22.845-1.702 42.971 2.319 53.87 3.96 10.734 4.046 22.731-.124 33.375-4.88 12.458-20.687 26.365-44.752 23.065-38.286-5.25-70.015-40.489-71.117-85.768-.86-35.333 25.59-62.853 55.806-71.912 4.532-1.359 9.462-1.944 14.482-1.808 24.939.676 52.075 19.167 43.386 49.178z","clipRule":"evenodd","fillRule":"evenodd"}))]);
}

Blobik2.defaultProps = {"preserveAspectRatio":"xMidYMid meet","data-bbox":"40.501 20 119 160","viewBox":"40.501 20 119 160","height":"200","width":"200","data-type":"shape","role":"presentation","aria-hidden":"true","aria-labelledby":"svgcid--p25fi-26yyt9"};

module.exports = Blobik2;

Blobik2.default = Blobik2;
